export const adminPrefix = "submarine";
